import React from "react";
import { Helmet } from "react-helmet";

import DocuBuilderBar from "./DocuBuilderBar";
import DocuBuilderPreview from "./DocuBuilderPreview";
import DocuBuilderSideBar from "./DocuBuilderSideBar";

import { StyledEditorStack } from "./styles";

export const DocuBuilder = ({
  id,
  name,
  title = "New Document",
  data = {},
  label = "Document",
  includeName = true,
  disabled,
  isLoading = false,
  previewLabel = "This is a Preview",
  isPreview = true,
  FormComponent,
  sideBarWidth = "300px",
  Template,
  ContextMenu,
  showSubmit = true,
  onDownload,
  // Forwarded to DocuBuilderBar — sibling action(s) rendered before Download.
  extraActions = null,
}) => {
  const builderProps = {
    id,
    name,
    label,
    includeName,
    disabled,
    ContextMenu,
    showSubmit,
    onDownload,
    extraActions,
  };

  const previewProps = {
    data,
    Template,
    isLoading,
    previewLabel,
    isPreview,
  };

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <DocuBuilderBar {...builderProps} />
      <StyledEditorStack>
        <DocuBuilderPreview {...previewProps} />
        <DocuBuilderSideBar
          FormComponent={FormComponent}
          sideBarWidth={sideBarWidth}
        />
      </StyledEditorStack>
    </>
  );
};

export default DocuBuilder;
